module.exports = __webpack_public_path__ + "img/parkIntroductionBanner.132ecfd4.png";